import { httpPOST, httpDELETE, encodeUrl } from './utils.js';
import { ACTIONS, ICONS } from '../const';
import { selectSection, selectCollections } from '../selectors/section';
import { newNotification } from 'actions/notifications';
import { addAural } from 'actions/aural_notification';

export const createCollection = (section_id, name) => (dispatch, getState) => {
    dispatch({
        type: ACTIONS.CREATE_COLLECTION,
        payload: {
            section_id: section_id,
            name,
        },
    });

    const url = encodeUrl`/api/section/${section_id}/tag/`;
    return httpPOST(url, null, {
        formData: {
            tag: name,
        },
    })
        .then(() => {
            const section = selectSection(getState(), section_id);

            dispatch(
                newNotification(
                    'Collection created',
                    `Created collection "${name}"`,
                    {
                        icon: ICONS.SUCCESS,
                    }
                )
            );
            return selectCollections(getState(), section).find(
                c => c.name === name
            );
        })
        .catch(() => {
            dispatch(
                newNotification('Error', 'Could not create collection', {
                    icon: ICONS.FAIL,
                })
            );
        });
};

export const deleteCollection = ({ section_id, name }) => dispatch => {
    dispatch({
        type: ACTIONS.DELETE_COLLECTION,
        payload: {
            section_id: section_id,
            name: name,
        },
    });

    const url = encodeUrl`/api/section/${section_id}/tag/${name}`;
    return httpDELETE(url)
        .then(res => {
            if (!res.ok) {
                throw new Error('HTTP error');
            }

            return dispatch(
                newNotification(
                    'Collection deleted',
                    `Deleted collection "${name}"`,
                    {
                        icon: ICONS.SUCCESS,
                    }
                )
            );
        })
        .catch(() =>
            dispatch(
                newNotification(
                    'Error',
                    `Could not delete collection "${name}"`,
                    {
                        icon: ICONS.FAIL,
                        dismissable: true,
                    }
                )
            )
        );
};

export const addContentToCollection = (content, collection) => dispatch => {
    dispatch({
        type: ACTIONS.ADD_CONTENT_TO_COLLECTION,
        payload: {
            content_id: content.id,
            section_id: collection.section_id,
            name: collection.name,
        },
    });

    const url = `/api/classmaterial/${content.id}/tag/`;
    return httpPOST(url, null, {
        formData: {
            tag: collection.name,
        },
    });
};

const removeContentFromCollection = (content, collection) => dispatch => {
    dispatch({
        type: ACTIONS.REMOVE_CONTENT_FROM_COLLECTION,
        payload: {
            content_id: content.id,
            section_id: collection.section_id,
            name: collection.name,
        },
    });

    const url = encodeUrl`/api/classmaterial/${content.id}/tag/${collection.name}/`;
    return httpDELETE(url);
};

export const modifyText = ({ add, remove, name }) => {
    const addedText = add.length
        ? `Added ${add.length} item${add.length === 1 ? '' : 's'} `
        : '';
    const andText = add.length && remove.length ? 'and ' : '';
    const removedText = remove.length
        ? `${add.length ? 'r' : 'R'}emoved ${remove.length} item${
              remove.length === 1 ? '' : 's'
          } `
        : '';
    const fromText = `${remove.length ? 'from' : 'to'} collection "${name}"`;
    return addedText + andText + removedText + fromText;
};

export const editCollection = ({
    transaction: { add, remove },
    collection,
}) => dispatch => {
    if (!(add.length || remove.length)) {
        return dispatch(addAural('Collection not modified'));
    }
    return Promise.all([
        ...add.map(content =>
            dispatch(addContentToCollection(content, collection))
        ),
        ...remove.map(content =>
            dispatch(removeContentFromCollection(content, collection))
        ),
    ])
        .then(() =>
            dispatch(
                newNotification(
                    'Collection modified',
                    modifyText({ add, remove, name: collection.name }),
                    {
                        icon: ICONS.SUCCESS,
                    }
                )
            )
        )
        .catch(() =>
            dispatch(
                newNotification(
                    'Error',
                    `Could not modify collection "${collection.name}"`,
                    {
                        icon: ICONS.FAIL,
                        dismissable: true,
                    }
                )
            )
        );
};



// WEBPACK FOOTER //
// ./src/actions/collections.js